import {
  ManageableStorageLocation,
  StorageLocationMemberInfo,
  StorageLocationPendingInvitation,
} from '@luggagehero/shared/interfaces';

import { StorageLocationActivationStatus, StorageLocationPendingTaskUI } from './storage-locations.interfaces';
export type SaveStatus = 'idle' | 'saving' | 'success' | 'error';

export type StorageLocationsState = {
  isLoadingList: boolean;
  isLoadingById: boolean;
  isCreating: boolean;
  isUpdating: boolean;
  isDeleting: boolean;
  error: string | null;
  /** The SELECTED ORGANIZATION's locations. Written only by list loads, which the API scopes by org. */
  storageLocations: ManageableStorageLocation[];
  /**
   * AM-4724: shops fetched individually by id, kept separate from the org's list. The Business
   * Profiles estate view links to any shop in the estate, so opening one used to push it into
   * `storageLocations` and it then showed up on the Locations page forever, under whichever
   * organization happened to be selected.
   */
  storageLocationsById: Record<string, ManageableStorageLocation>;
  selectedStorageLocations: string[];
  hasLoadedListOnce: boolean;
  /**
   * AM-4723: the normalised search query the currently-loaded list answers, or null before any load.
   * "Have I loaded?" and "have I loaded THIS query?" are different questions, and conflating them is
   * what produced both the request loop and the permanently-empty page after a zero-result search.
   */
  loadedForQuery: string | null;
  searchQuery?: string | null;
  hasSearchedBefore: boolean;
  saveStatusById: Record<string, SaveStatus>;
  saveErrorById: Record<string, unknown>;
  storageLocationsPendingTasks: Record<string, StorageLocationPendingTaskUI[]>;
  /** AM-4710: gate readiness + whether the partner has asked us to review the location. */
  activationStatusByStorageLocationId: Record<string, StorageLocationActivationStatus>;
  /** In-flight state of the publish press, so the button can't be double-fired. */
  reviewRequestStatusById: Record<string, SaveStatus>;
  membersByStorageLocationId: Record<string, StorageLocationMemberInfo[]>;
  pendingInvitationsByStorageLocationId: Record<string, StorageLocationPendingInvitation[]>;
};

export const initialState: StorageLocationsState = {
  isLoadingList: false,
  isLoadingById: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  error: null,
  storageLocations: [],
  storageLocationsById: {},
  selectedStorageLocations: [],
  hasLoadedListOnce: false,
  loadedForQuery: null,
  searchQuery: null,
  hasSearchedBefore: false,
  saveStatusById: {},
  saveErrorById: {},
  storageLocationsPendingTasks: {},
  activationStatusByStorageLocationId: {},
  reviewRequestStatusById: {},
  membersByStorageLocationId: {},
  pendingInvitationsByStorageLocationId: {},
};
